import config from 'config';
import io from 'socket.io-client';
import store from '../redux';
import { getUser } from '../redux/slices/authSlice';

const api = new URL(config.calendarApiV4.socketBaseURL);
const state = store.getState();
const user = getUser(state);

const socket = io.connect(`${api.origin}/icalendar-v4`, {
    transports: ['websocket'],
    auth: {
        userId: user?.userId
    }
});

export default socket;